<div
  class="native-video-upload flex flex-col"
  [class.mb-[20px]]="selectedVideo"
>
  <ark-button
    *ngIf="showPicker"
    type="neutral"
    leftIcon="system-plus"
    iconColor="cta"
    [disabled]="uploading"
    (click)="onUploadButtonClick(nativeVideoFile)"
  >
    ADD VIDEO
  </ark-button>
  <div *ngIf="showPicker" class="text-black text-[13px] font-normal mt-[10px]">
    Upload video (Max 60 sec)
  </div>

  <input
    #nativeVideoFile
    type="file"
    accept="video/mp4,video/quicktime,.mp4,.mov"
    class="hidden"
    (change)="onVideoSelected($event)"
  />

  <div
    *ngIf="selectedVideoPreviewUrl"
    class="native-video-preview-shell relative mt-[10px]"
  >
    <video
      #nativeVideoPreview
      class="native-video-preview w-full bg-black rounded-[4px]"
      [class.native-video-preview-pending]="!previewFrameReady"
      [src]="selectedVideoPreviewUrl"
      tabindex="-1"
      controls
      playsinline
      preload="auto"
      (loadedmetadata)="onPreviewLoaded($event)"
      (loadeddata)="onPreviewState('loadeddata', $event)"
      (canplay)="onPreviewState('canplay', $event)"
      (seeked)="onPreviewFrameReady()"
      (playing)="onPreviewState('playing', $event)"
      (error)="onPreviewError($event)"
    ></video>

    <button
      type="button"
      class="native-video-remove-button"
      aria-label="Remove selected video"
      [disabled]="uploading"
      (click)="removeCurrentVideo()"
    >
      <ark-icon icon="system-trash" size="small" color="dark"></ark-icon>
    </button>
  </div>

  <div
    *ngIf="selectedVideo"
    class="native-video-meta-row"
  >
    <span class="native-video-file-name">
      {{ selectedVideo.name }}
    </span>
    <span *ngIf="videoDuration !== null" class="native-video-duration">
      {{ videoDuration | number: '1.0-1' }}s / {{ maxDurationSeconds }}s
    </span>
  </div>

  <div
    *ngIf="previewWarningMessage"
    class="text-sm font-semibold text-[#ff3333] mt-[10px]"
  >
    {{ previewWarningMessage }}
  </div>

  <ark-button
    *ngIf="selectedVideo && (!uploadResponse || uploading) && !uploadErrorMessage"
    class="pt-5"
    (click)="uploadVideo()"
    [disabled]="uploading || !durationChecked || selectedVideoTooLong"
  >
    {{ uploading ? 'Uploading Video' : 'Upload Video' }}
  </ark-button>

  <div
    *ngIf="uploading"
    class="native-video-upload-progress mt-3"
    aria-live="polite"
  >
    <div class="native-video-upload-progress-header">
      <span>Uploading video</span>
      <span>{{ uploadProgressLabel }}</span>
    </div>
    <div
      class="native-video-upload-progress-track"
      role="progressbar"
      aria-label="Video upload progress"
      [attr.aria-valuenow]="uploadProgress"
      aria-valuemin="0"
      aria-valuemax="100"
    >
      <div
        class="native-video-upload-progress-fill"
        [style.width.%]="uploadProgress"
      ></div>
    </div>
  </div>

  <div
    *ngIf="uploadErrorMessage"
    class="text-sm font-semibold text-[#ff3333] mt-[10px]"
  >
    {{ uploadErrorMessage }}
  </div>
</div>
